<a *ngIf="!actions && !mobile"
   [ngClass]="navbarItem.isSelected ? 'bg-theme-primary-50 text-theme-primary-600 shadow-sm' : 'text-gray-500 hover:bg-gray-100/80 hover:text-gray-900'"
   class="select-none cursor-pointer relative flex items-center px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 group h-9">
  <span class="relative z-10 whitespace-nowrap">{{ navbarItem.title }}</span>
  <div *ngIf="navbarItem.isSelected" class="absolute bottom-0 inset-x-4 h-0.5 bg-theme-primary-500 rounded-full"></div>
</a>

<a *ngIf="!actions && mobile"
   [ngClass]="navbarItem.isSelected ? 'bg-theme-primary-50 text-theme-primary-700 shadow-sm' : 'text-gray-600 hover:bg-gray-100/80'"
   class="select-none cursor-pointer block px-4 py-2 text-base font-medium rounded-xl transition-all">
  {{ navbarItem.title }}
</a>

<div #itemContainer
     [ngClass]="navbarItem.isSelected && navbarItem.isExpanded ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4 pointer-events-none'"
     class="absolute inset-x-0 transition-all duration-300 ease-out z-[49]">
  <div *ngIf="actions" class="w-full h-24 px-6 flex items-center">
    <!-- `py-2` is load-bearing, not cosmetic (#224). This is an `overflow-x-auto` scroller, and CSS forces the
         other axis to `auto` too, so anything sticking out of an entry's own 72 px box is clipped here. The
         status badge on a large entry straddles its icon tile's top edge and pokes ~3 px above the entry — the
         8 px of padding gives it room, because overflow clips at the PADDING box, not the content box. The row
         is still visually unchanged: 72 px + 16 px = 88 px, centred in the fixed h-24 (96 px) parent. -->
    <div class="w-full flex items-center space-x-6 overflow-x-auto no-scrollbar py-2">
      <ng-content></ng-content>
    </div>
  </div>
</div>

